import { STORE_NAME } from './reducer';
/**
 * Returns whether the rendering measurement panel is on screen.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean}
 */
export function isRenderStatsOpen(state) {
    return state[STORE_NAME]?.renderStats ?? false;
}
